import { render, staticRenderFns } from "./GestionEmpleados.vue?vue&type=template&id=21c41912"
import script from "./GestionEmpleados.vue?vue&type=script&lang=js"
export * from "./GestionEmpleados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports